import { teamNavigationItems, teamRoutes } from "./router";
export class TeamModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[TeamModule] Registered");
        return { id: "team", name: "Team Module", version: "1.0.0" };
    }
    getRoutes() {
        return teamRoutes;
    }
    getNavigationItems() {
        return teamNavigationItems;
    }
    getComponent(_slotName) {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[TeamModule] Unregistered");
        this.contracts = null;
    }
}
export default new TeamModule();
